import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import Aviator from 'aviator';
import { DndProvider } from 'react-dnd';
import { TouchBackend } from 'react-dnd-touch-backend';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { MultiBackend, TouchTransition } from 'dnd-multi-backend';
import App from 'src/apps/mydb/App';
import appRoutes from 'src/apps/mydb/routes';
import { RootStore, StoreContext } from 'src/stores/mobx/RootStore';
import {
  addonLifecycle,
} from 'src/chemkit';
import {
  prepareChemkitBoot,
  renderChemkitBootFailure,
} from '../../../addon/boot/startMydbApp';

const { ADDON_READY_TIMEOUT_MS } = addonLifecycle;

Sentry.init({
  sendClientReports: false,
  dsn: process.env.SENTRY_FRONTEND_DSN,
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: process.env.SENTRY_FRONTEND_SAMPLE_RATE,
});
const backendOptions = {
  backends: [
    {
      id: 'touch',
      backend: TouchBackend, // Touch Drag Support
      options: { enableMouseEvents: true },
      transition: TouchTransition, // Detects if touch is used
    },
    {
      id: 'html5',
      backend: HTML5Backend, // Mouse Drag Support
    },
  ],
};
document.addEventListener('DOMContentLoaded', async () => {
  const domElement = document.getElementById('app');
  if (!domElement) {
    return;
  }

  const storeInstance = RootStore.create({});

  try {
    await prepareChemkitBoot({ storeInstance, timeoutMs: ADDON_READY_TIMEOUT_MS });

    ReactDOM.render(
      <StoreContext.Provider value={storeInstance}>
        <DndProvider backend={MultiBackend} options={backendOptions}>
          <App />
        </DndProvider>
      </StoreContext.Provider>,
      domElement
    );
    appRoutes().then(() => { Aviator.dispatch(); });
  } catch (error) {
    renderChemkitBootFailure(domElement, error);
  }
});
